import styled from 'styled-components';
import { SafeHtml, SafeHtmlProps } from 'ia-react-core';
import { FC } from 'react';

export const StyledSafeHtml = styled<FC<SafeHtmlProps>>(SafeHtml)`
  display: flex;
  flex-flow: wrap;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  > p {
    margin-top: 5px;
    margin-bottom: 5px;
    :first-child{
      margin-top:0px ;
    }
    :last-child{
      margin-bottom:0px ;
    }
    a {
      outline: none;
      text-decoration: none;
      font-weight: 600;
      flex-flow: wrap;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.blue5};
      &:hover {
        text-decoration: inherit;
      }
      &:active {
        color: ${({ theme }) => theme.colors.blue10};
        text-decoration: inherit;
      }
      &:focus {
        box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.lighter};  
      }
    }

  }
`;
